import actions from "./actions";
export default {
  namespaced: true,
  state: {
    dataLoading: false
  },

  getters: {
    dataLoading: state => {
      return state.dataLoading;
    }
  },

  mutations: {
    setDataLoading(state, dataLoading) {
      state.dataLoading = dataLoading;
    }
  },
  actions
};